import $ from 'jquery';
// eslint-disable-next-line import-x/no-unassigned-import
import 'jquery-validation';
import validationOptions from './validation-options';

const $link = $('nav a[href="/anfrage"]');

$link.on('click', (event: JQuery.Event) => {
	event.preventDefault();

	void (async () => {
		const dialog = document.createElement('dialog');
		const closeButton = document.createElement('button');
		closeButton.textContent = 'Schließen';
		closeButton.className = 'close-button';
		closeButton.addEventListener('click', () => {
			dialog.close();
			dialog.remove();
		});
		dialog.append(closeButton);
		document.body.append(dialog);

		// Load the content of the dialog from the server
		const data: unknown = await $.get('/anfrage');
		const htmlContent =
			typeof data === 'string'
				? ($(data).find('#form-content').html() ?? '')
				: '';
		dialog.insertAdjacentHTML('afterbegin', htmlContent);
		dialog.showModal();
		$('dialog form').validate(validationOptions);
	})();
});
